import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { ArrowLeft, ShoppingCart } from 'lucide-react';
import { useTheme } from '../../context/ThemeContext';
import '../../styles/productDetail.css';

/**
 * Mobile-only navbar for the Product Details page.
 * Provides quick back navigation and cart access with dynamic badges.
 */
const ProductNavbar = () => {
  const navigate = useNavigate();
  const cartItems = useSelector((state) => state.cart.cartItems);
  const { theme } = useTheme();

  return (
    <div className="product-mobile-nav">
      {/* Left Action: Go Back */}
      <button 
        onClick={() => navigate(-1)} 
        className="mobile-nav-btn" 
        aria-label="Go Back"
      >
        <ArrowLeft size={24} />
      </button>

      {/* Center Action: Home Logo */}
      <div onClick={() => navigate('/')} style={{ cursor: 'pointer' }}>
        <img 
          src={theme === 'light' ? '/RegardTraderLogo_black.png' : '/RegardTradersLogo.png'} 
          alt="REGARD TRADERS" 
          className="mobile-nav-logo" 
        />
      </div>

      {/* Right Action: Cart Page Link */}
      <button 
        onClick={() => navigate('/cart')} 
        className="mobile-nav-btn mobile-nav-cart-wrapper"
        aria-label="View Cart"
      >
        <ShoppingCart size={24} />
        {cartItems.length > 0 && (
          <span className="mobile-nav-badge">
            {cartItems.length}
          </span>
        )}
      </button>
    </div>
  );
};

export default ProductNavbar;
